module.exports = __webpack_public_path__ + "img/00046.cbb59396.webp";